export const S3_URL = 'https://audatex-cms-image-bucket.s3-ap-southeast-1.amazonaws.com/'